import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import '../../App.css';
import { useNavigate } from "react-router-dom";

export default function HeaderSidebar() {

    const navigate = useNavigate();


    const handleLogout = () => {
    // ❌ Remove token
    localStorage.removeItem("token");

    // (optional) remove user info if stored
    // localStorage.removeItem("user");

    // 🔁 Redirect to login
    navigate("/login");
  };
  return (
    <div>

      {/* TOP NAVBAR */}
      <nav className="navbar navbar-dark bg-dark fixed-top px-3 fixed-top">
        <div className="container-fluid">

          {/* BRAND NAME - LEFT */}
          <span className="navbar-brand fw-bold">Shiv Trade Link</span>

          {/* MOBILE TOGGLE BUTTON */}
          <button
            className="navbar-toggler d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* USER PROFILE (visible only on laptop/tablet) */}
          <div className="text-white d-none d-md-block">
            👤 User Profile
          </div>
        </div>
      </nav>

      {/* ⭐ DESKTOP SIDEBAR — moved OUTSIDE navbar */}
      <div
        className="bg-dark text-white p-3 d-none d-md-block"
        style={{
          width: "220px",
          height: "100vh",
          position: "fixed",
          top: "56px",
          left: 0,
        }}
      >
        <ul className="list-unstyled mt-3">
          <li className="mb-3"><a href="/dashboard" className="text-white text-decoration-none">🏠 Dashboard</a></li>
          <li className="mb-3"><a href="/add-deal" className="text-white text-decoration-none">➕ Add Deal</a></li>
          <li className="mb-3"><a href="/my-deals" className="text-white text-decoration-none">🤝 My Deals</a></li>
          <li className="mb-3"><a href="/reports" className="text-white text-decoration-none">📊 Reports</a></li>
          <li className="mb-3"><a href="/settings" className="text-white text-decoration-none">⚙️ Settings</a></li>

           <li className="mt-4">
              <button
                className="btn btn-danger w-100"
                onClick={handleLogout}
              >
                🚪 Logout
              </button>
            </li>
        </ul>
      </div>

      {/* ⭐ MOBILE SIDEBAR (Offcanvas) */}
      <div
        className="offcanvas offcanvas-start bg-dark text-white"
        tabIndex="-1"
        id="sidebarMenu"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Menu</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">
          <ul className="list-unstyled mt-3">
            <li className="mb-3"><a className="text-white text-decoration-none" href="/dashboard">🏠 Dashboard</a></li>
            <li className="mb-3"><a className="text-white text-decoration-none" href="/add-deal">➕ Add Deal</a></li>
            <li className="mb-3"><a className="text-white text-decoration-none" href="/my-deals">🤝 My Deals</a></li>
            <li className="mb-3"><a className="text-white text-decoration-none" href="/reports">📊 Reports</a></li>
            <li className="mb-3"><a className="text-white text-decoration-none" href="/settings">⚙️ Settings</a></li>
             <li className="mt-4">
              <button
                className="btn btn-danger w-100"
                onClick={handleLogout}
                data-bs-dismiss="offcanvas"
              >
                🚪 Logout
              </button>
            </li>
          </ul>
        </div>
      </div>

    </div>
  );
}
